import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    collection,
    query,
    where,
    onSnapshot,
    getDocs,
    orderBy,
    writeBatch,
} from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import { MdClose, MdOutlineWorkHistory, MdSearch } from "react-icons/md";
import Queue_verify from "./queue_verify.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity",
    Description: "Discover aooz's free and premium online services.",
    keywords: "aooz services, online tools, seo tools",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png",
};
export default function Log_history() {
    const [isLoading, setIsLoading] = useState(true);
    const [logHistoryData, setLogHistoryData] = useState([]);
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    const [Voucherselected, setVoucherselected] = useState("All Types");
    const [oucherlist, setoucherlist] = useState([]);
    const [logid, setLogid] = useState("");
    const [queueopen, setQueueopen] = useState(false);

    useEffect(() => {
        const today = new Date();

        const to = new Date(today);
        to.setHours(0, 0, 0, 0);

        const from = new Date(today);
        from.setDate(from.getDate() - 6); // last 7 days
        from.setHours(0, 0, 0, 0);

        const format = (d) =>
            `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

        setFrom_date(format(from));
        setTo_date(format(to));
    }, []);
    useEffect(() => {
        const companyId = Cookies.get("select_company_uid");
        const deleteOldLogs = async () => {
            if (!companyId || !Voucherselected) return;

            const cutoff = Timestamp.fromDate(
                new Date(Date.now() - 30 * 60 * 1000)
            );

            const historyQuery = query(
                collection(db, "companies", companyId, "log_history"),
                where("log_status", "==", false),
                where("date_time", "<", cutoff),
                orderBy("date_time", "desc")
            );

            const snapshot = await getDocs(historyQuery);
            if (snapshot.empty) return;

            const batch = writeBatch(db);
            snapshot.docs.forEach(doc => batch.delete(doc.ref));
            await batch.commit();
        };

        deleteOldLogs();
    }, []);
    const get_Reports = () => {
        const guid = Cookies.get("guid");
        const companyId = Cookies.get("select_company_uid");

        if (!guid) {
            Toastshow("Login expired. Please relogin.");
            return;
        }
        if (!companyId) {
            Toastshow("No company selected.");
            return;
        }
        // 🔒 REQUIRED
        if (!from_date || !to_date) return;

        const startDate = new Date(from_date);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(to_date);
        endDate.setHours(23, 59, 59, 999);

        const startTimestamp = Timestamp.fromDate(startDate);
        const endTimestamp = Timestamp.fromDate(endDate);
        let historyQuery;
        if (Voucherselected === "All Types") {


            if (Voucherselected === "All Types") {
                historyQuery = query(
                    collection(db, "companies", companyId, "log_history"),
                    where("date_time", ">=", startTimestamp),
                    where("date_time", "<=", endTimestamp),
                    orderBy("date_time", "desc")
                );
            } else {
                historyQuery = query(
                    collection(db, "companies", companyId, "log_history"),
                    where("date_time", ">=", startTimestamp),
                    where("date_time", "<=", endTimestamp),
                    where("history_type", "==", Voucherselected),
                    orderBy("date_time", "desc")
                );
            }
        }
        const unsubscribe = onSnapshot(
            historyQuery,
            async (snapshot) => {
                try {
                    const results = await Promise.all(
                        snapshot.docs.map(async (docSnap) => {
                            const data = docSnap.data();

                            const ledgerQuery = query(
                                collection(db, "companies", companyId, "ledger_accounts"),
                                where("accountguid", "==", data.guid)
                            );

                            const ledgerSnap = await getDocs(ledgerQuery);
                            let ledger = null;

                            if (!ledgerSnap.empty) {
                                const d = ledgerSnap.docs[0];
                                ledger = {
                                    id: d.id,
                                    ...d.data(),
                                };
                            }

                            return {
                                id: docSnap.id,
                                ...data,
                                accounts_ledger: ledger,
                            };
                        })
                    );

                    setoucherlist((prev) => {
                        const list = [...prev];
                        results.forEach((v) => {
                            if (v.history_type && !list.includes(v.history_type)) {
                                list.push(v.history_type);
                            }
                        });
                        return list;
                    });

                    setLogHistoryData(results);
                    setIsLoading(false);
                } catch (err) {
                    console.error("Error:", err);
                    setIsLoading(false);
                }
            },
            (err) => console.error("Snapshot error:", err)
        );

        return () => unsubscribe();
    };

    useEffect(() => {
        if (!from_date || !to_date) return;
        get_Reports();
    }, [Voucherselected, from_date, to_date]);

    return (
        <div className="items-back">
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div className="button-ui0 text-h2 bold p-2">
                                    <MdOutlineWorkHistory className="icon" />
                                    Log history
                                </div>
                            </td>
                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="post-container p-2">
                <div className="ui-grid">
                    <div className="ui-items items-back p-2">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-h2">Transaction</td>
                                    <td>
                                        <div className="text-h2 bold">
                                            {logHistoryData.length}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="ui-items items-back p-2">
                        <select
                            className="text-h2 bold p-11"
                            value={Voucherselected}
                            onChange={(e) => setVoucherselected(e.target.value)}
                        >
                            <option value="All Types">All Types</option>
                            {oucherlist.map((item, index) => (
                                <option key={index} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="ui-items items-back p-11">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <input
                                            value={from_date}
                                            type="date"
                                            onChange={(e) => setFrom_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <input
                                            value={to_date}
                                            type="date"
                                            onChange={(e) => setTo_date(e.target.value)}
                                        />
                                    </td>

                                    <td>
                                        <div onClick={get_Reports} className="button-ui2 p-1">
                                            <MdSearch className="icon cursor" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="post-container p-2">
                <div className="post_div">
                    <div className="ui-grid_voucher">
                        {isLoading ? (
                            <></>
                        ) : logHistoryData.length === 0 ? (
                            <div className="text-h2 bold p-5">No voucher found</div>
                        ) : window.innerWidth > 768 ? (
                            <table className="voucher-table-desktop fcap">
                                <thead>
                                    <tr>
                                        <th>Queue</th>
                                        <th>Status</th>
                                        <th>Note</th>
                                        <th>Date & Time</th>
                                        <th>Login</th>
                                        <th>Description</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {logHistoryData.map((row) => (
                                        <tr key={row.id} className="tr_hover">
                                            <td className="p-11" width={20}>{row.queue}</td>

                                            <td width={60}>
                                                <div
                                                    onClick={() => {
                                                        setLogid(row);
                                                        setQueueopen(true);
                                                    }}
                                                    className="b-1 rounded p-11 text-h2 cursor bold"
                                                >

                                                    {row.log_status === true ? (
                                                        <>{row.verify_status === true ? <div  >Complete</div> : <div className="red">Reject</div>}</>
                                                    ) : (
                                                        <div className="green">Pending</div>
                                                    )}

                                                </div>
                                            </td>

                                            {/* {row.servicetablename === "accountingfinancedb" && (
                                                <>
                                                    {row.history_type === "accounting_user" && (
                                                        <td width={60}>
                                                            <div
                                                                onClick={() => {
                                                                    setLogid(row);
                                                                    setQueueopen_accounting(true);
                                                                }}
                                                                className="p-11 text-h2 cursor bold"
                                                            >

                                                                {row.log_status === true ? (
                                                                    <>{row.verify_status === true ? <div className="green">Complete</div> : <div className="red">Reject</div>}</>
                                                                ) : (
                                                                    <div className="green">Pending</div>

                                                                )}

                                                            </div>
                                                        </td>
                                                    )}
                                                </>
                                            )} */}
                                            <td >{row.verify_note || "N/A"}</td>

                                            <td width={150} className="text-h3">
                                                {row.date_time?.toDate
                                                    ? row.date_time
                                                        .toDate()
                                                        .toLocaleString()
                                                    : "No date"}
                                            </td>

                                            <td width={130} className="bold">
                                                {row.accounts_ledger?.name || "N/A"}
                                            </td>

                                            <td>{row.description || "N/A"}</td>

                                            <td width={80} className="text-h3">
                                                <div
                                                    className={
                                                        `bold text-h3 fcap ` +
                                                        (row.history_type === "delete"
                                                            ? "red"
                                                            : "")
                                                    }
                                                >
                                                    {row.history_type}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            logHistoryData.map((row) => (
                                <div
                                    key={row.id}
                                    className="ui-items items-back p-11 shadow hover rounded"
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="text-h1 bold">
                                                        {row.accounts_ledger?.name || "N/A"}
                                                    </div>
                                                    <div className="text-h3">
                                                        A/c: {row.guid || "--"}
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="b-top">
                                                    <div className="text-h2 bold">
                                                        {row.history_type}
                                                    </div>

                                                    <div className="text-h3 text-r">
                                                        {row.date_time?.toDate
                                                            ? row.date_time
                                                                .toDate()
                                                                .toLocaleString()
                                                            : "No date"}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
            <Queue_verify data={logid} isOpen={queueopen} onClose={() => setQueueopen(false)} />
        </div>
    );
}
